import { createSearchParams, To } from 'react-router-dom';

import { Argenta } from '@argenta-types/homebank';

import { VacancyTo } from '../../types/routes.types';

export const mapVacancyTo = (
  vacancyTo: VacancyTo,
  language: Argenta.HomeBank.Global.I18n.Language
): To => {
  return typeof vacancyTo === 'string'
    ? `/${language}/${vacancyTo}`
    : {
        pathname: `/${language}/${vacancyTo.pathname}`,
        search: createSearchParams(vacancyTo.queryParams).toString(),
        hash: vacancyTo.hash,
      };
};
